import "./banner/Banner.css";
import Banner from "./banner/Banner";
import About_Content from "./about_content/About_Content";
import Our_Services from "./our_services/Our_Services";
import Technology from "./technology/Technology";
import Work_Process from "./work_process/Work_Process";
import Trusted_Brands from "./trusted_brands/Trusted_Brands";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";
import Contacts from "./contacts/Contacts";

function Home() {
  return (
    <>
      <Banner />
      <About_Content/>
      <Our_Services/>
      <Technology/>
      <Trusted_Brands/>
      <Work_Process/>
      <Book_Vehicle/>
      <Contacts/>
    </>
  );
}

export default Home;
